import { CONFIG_RESOLVE, ConfigResolve } from './config.resolve';

export { ConfigResolve, CONFIG_RESOLVE };
